/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddParcelDto } from '../../models/add-parcel-dto';
import { ParcelResponseDto } from '../../models/parcel-response-dto';

export interface GlsControllerCreateParcel$Params {
  
    /**
     * Array of parcels to create
     */
    body: Array<AddParcelDto>
}

export function glsControllerCreateParcel(http: HttpClient, rootUrl: string, params: GlsControllerCreateParcel$Params, context?: HttpContext): Observable<StrictHttpResponse<ParcelResponseDto>> {
  const rb = new RequestBuilder(rootUrl, glsControllerCreateParcel.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ParcelResponseDto>;
    })
  );
}

glsControllerCreateParcel.PATH = '/couriers/gls/add-parcel';
